import React, { Suspense } from "react";
import { Switch, Redirect } from "react-router-dom";
import { AuthPagesPath, MainPagesPath } from "./Paths";
import { Route } from "react-router-dom";
import PrivateRouter from "./PrivateRouter";
import Overlay from "../components/Overlay";
import Login from "../pages/Login";
import CustomerSchemes from "../pages/CustomerSchemes";

const AppRouter = ({ isAuthenticated, ...props }) => {
  return (
    <Suspense fallback={<Overlay />}>
      <Switch>
        {isAuthenticated && <PrivateRouter setToken={props.setToken} />}
        <Redirect exact from="/" to={AuthPagesPath.login} />
        <Route exact path={AuthPagesPath.login} component={Login} />
        <Route
          exact
          path={MainPagesPath.userSchemes + "/:customerCode/:token/:langId?"}
          render={(props) => <CustomerSchemes {...props} />}
        />
        <Route path="*" render={() => <Redirect to="/" />} />
        {props.children}
      </Switch>
    </Suspense>
  );
};

export default AppRouter;
